module.exports = __webpack_public_path__ + "static/img/AnyDesk.66c2906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AnyDesk.png
// module id = tSqW
// module chunks = 1